import React, { useEffect, useState } from 'react';

import { CustomGridLayout } from '../../../../../shared/Cards/CustomCard';
import {
    CustomButtonList,
    CustomCalenderInput,
    CustomDropDown,
    CustomInput,
    CustomInputNumber,
    CustomMultiselect,
} from '../../../../../shared/Input/AllInputs';
import formValidation from '../../../../../utils/validations';
import { useDispatch, useSelector } from 'react-redux';
import { conditionDropdowns } from '../../../../../utils/dropdownConstants';
import CustomPickList from '../../../../../shared/Input/CustomPickList';
import useProfitCenters from '../../../../../hooks/Inventory/useProfitCenters';
import { purchasedServiceDataPoints } from '../../../../../utils/reportDataPoints';
import { getReportFilters } from '../../../../../redux/actions/More/ReportAction';
import { snakeToCapitalized } from '../../../../../utils/commonFunctions';

export default function PurchasedServices({ info, hideColumn = false, onChange }) {
    const dispatch = useDispatch();
    let { clubsDropdown } = useSelector((state) => state.settings.business);
    const { profitCenterDropdown } = useProfitCenters();

    const [data, setData] = useState({
        club: '',
        profitCenter: '',
        services: [],
        countType: 'AMOUNT_VALUE',
        countCondition: 'GREATER_THAN',
        count: 0,
        selectedDataPoints: [],
        timePeriod: 'ALL_TIME',
        noOfDays: '',
        specificDate: null,
    });

    useEffect(() => {
        if (info) {
            setData((prev) => ({
                ...prev,
                club: info.club,
                profitCenter: info.profitCenter,
                services: info.services,
                countType: info.countType,
                countCondition: info.countCondition,
                count: info.count,
                selectedDataPoints: info.selectedDataPoints || [],
                timePeriod: info.timePeriod,
                noOfDays: info.noOfDays,
                specificDate: info.specificDate ? new Date(info.specificDate) : null,
            }));
        }
    }, [info]);

    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, data);
        setData((prev) => {
            let _obj = { ...prev, [name]: value, formErrors };
            onChange({ name: 'PURCHASED_SERVICES', value: _obj });
            return _obj;
        });
    };

    const [servicesOptions, setServicesOptions] = useState([]);

    useEffect(() => {
        if (data?.profitCenter) {
            dispatch(
                getReportFilters({ profitCenter: data?.profitCenter, type: 'SERVICE' }, (res) => {
                    setServicesOptions(res.map((item) => ({ name: item.name, value: item._id })));
                }),
            );
        }
    }, [data?.profitCenter]);
    const itemTemplate = (item) => {
        return (
            <div className="text-sm">
                <div>{item.name}</div>
                <div className="text-secondary capitalize font-semibold">{snakeToCapitalized(item?.type)?.toLowerCase()}</div>
            </div>
        );
    };
    return (
        <>
            <CustomGridLayout>
                <CustomDropDown data={data} onChange={handleChange} name="club" options={clubsDropdown} />
                <CustomDropDown data={data} onChange={handleChange} name="profitCenter" options={profitCenterDropdown} />
                <CustomMultiselect data={data} onChange={handleChange} name="services" options={servicesOptions} />
                <div className="font-bold text-xl col-12">Number of Purchase</div>
                <CustomDropDown
                    data={data}
                    onChange={handleChange}
                    name="countType"
                    label="Value/Quantity"
                    options={[
                        {
                            name: 'Amount Value',
                            value: 'AMOUNT_VALUE',
                        },
                        {
                            name: 'Item Quantity',
                            value: 'ITEM_QUANTITY',
                        },
                    ]}
                />
                <CustomDropDown data={data} onChange={handleChange} name="countCondition" label="Condition" options={conditionDropdowns} />
                <CustomInputNumber
                    data={data}
                    onChange={handleChange}
                    name="count"
                    prefix={data?.countType === 'AMOUNT_VALUE' ? '$' : ''}
                    label={data?.countType === 'AMOUNT_VALUE' ? 'Amount Value' : 'Item Quantity'}
                />
                <div className="font-bold text-xl col-12">Time Period</div>
                <CustomButtonList
                    data={data}
                    onChange={handleChange}
                    name="timePeriod"
                    options={[
                        {
                            name: 'Specific Date',
                            value: 'SPECIFIC_DATE',
                        },
                        {
                            name: 'Relative to today',
                            value: 'RELATIVE_TO_TODAY',
                        },
                        {
                            name: 'All Time',
                            value: 'ALL_TIME',
                        },
                    ]}
                />

                {data?.timePeriod === 'SPECIFIC_DATE' && (
                    <CustomCalenderInput label="Specific Date" onChange={handleChange} name="specificDate" maxDate={new Date()} />
                )}
                {data?.timePeriod === 'RELATIVE_TO_TODAY' && <CustomInputNumber label="Enter no of days" data={data} onChange={handleChange} name="noOfDays" />}

                {!hideColumn && (
                    <CustomPickList
                        name="selectedDataPoints"
                        label="Select Data Points"
                        selected={data?.selectedDataPoints}
                        sourceData={purchasedServiceDataPoints}
                        onPickListChange={handleChange}
                        itemTemplate={itemTemplate}
                    />
                )}
            </CustomGridLayout>
        </>
    );
}
